import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../domain';
import {X9ContentStateStore} from './common/X9ContentStateStore';
import {StudentFlashcards} from './flashcard/classroom/StudentFlashcards';
import {StudentGapFilling} from './gap-filling/classroom/student/StudentGapFilling';
import {StudentGroupingExercise} from './grouping-exercise/classroom/StudentGroupingExercise';
import {StudentMatchingQuestion} from './matching-question/classroom/student/StudentMatchingQuestion';
import {StudentMcq} from './mcq/classroom/student/StudentMcq';
import {StudentOpenEndedQuestionInline} from './open-ended-question-inline/classroom/StudentOpenEndedQuestionInline';
import {StudentOpenEndedQuestion} from './open-ended-question/classroom/StudentOpenEndedQuestion';
import {StudentSelectQuestion} from './select-question/classroom/StudentSelectQuestion';
import {StudentSlideShow} from './slideshow/classroom/StudentSlideShow';
import {X9StaticHtmlView} from './static-html/X9StaticHtmlView';
import {X9StaticImageView} from './static-image/X9StaticImageView';
import {StudentSyncedAudio} from './synced-audio/classroom/student/StudentSyncedAudio';
import {StudentSyncedVideo} from './synced-video/classroom/student/StudentSyncedVideo';

interface Props {
  x9: X9Content | X9ContentSnapshot,
  store: X9ContentStateStore,
  lessonType?: string | undefined
}

export class X9StudentComponent extends React.Component<Props> {

  render() {
    const {x9, store, lessonType} = this.props;

    switch (x9.ContentType) {
      case 'static-html':
        return <X9StaticHtmlView x9={x9}/>;
      case 'static-image':
        return <X9StaticImageView x9={x9}/>;
      case 'matching-question':
        return (<StudentMatchingQuestion x9={x9} store={store} lessonType={lessonType}/>);
      case 'select-question':
        return (<StudentSelectQuestion x9={x9} store={store} lessonType={lessonType}/>);
      case 'gap-filling':
        return (<StudentGapFilling x9={x9} store={store} lessonType={lessonType}/>);
      case 'multiple-choice-question':
        return (<StudentMcq x9={x9} store={store} lessonType={lessonType}/>);
      case 'grouping-exercise':
        return (<StudentGroupingExercise x9={x9} store={store} lessonType={lessonType}/>);
      case 'flashcards':
        return (<StudentFlashcards x9={x9} store={store}/>);
      case 'slideshow':
        return (<StudentSlideShow x9={x9} store={store} lessonType={lessonType}/>);
      case 'open-ended-question':
        return (<StudentOpenEndedQuestion x9={x9} store={store}/>);
      case 'open-ended-question-inline':
        return (<StudentOpenEndedQuestionInline x9={x9} store={store}/>);
      case 'synced-audio':
        return (<StudentSyncedAudio x9={x9} store={store} lessonType={lessonType}/>);
      case 'synced-video':
        return (<StudentSyncedVideo x9={x9} store={store} lessonType={lessonType}/>);
    }
    return null;
  }
}
